import React from 'react';
import { defineMessages } from '@vistaprint-org/digital-i18n-utils';
import { useTranslation } from 'react-i18next';
import {
  Link,
  Typography,
  FlexBox,
  FluidImage,
  ModalDialog,
  ModalDialogBody,
  ModalDialogContent,
  ModalDialogHeader,
  ModalDialogTitle,
  ModalDialogCloseButton,
  ModalDialogNav,
} from '@vp/swan';

import './PublishModal.scss';

interface Props {
  isModalOpened: boolean;
  setModalStatus: (status: string | null) => void;
  publishedDomain: string;
}
const messages = defineMessages({
  congrats: 'Congratulations! your VistaConnect site is published',
  changesLive: 'Your changes are now live. To check your site, scan the QR code below.',
  changesLiveMobile: 'Your changes are now live. To check your site, click the link below.',
  confettiAlt: 'Confetti',
  return: 'Return to studio',
  view: 'View live version',
  copyLink: 'Copy Link',
  linkCopied: 'Link copied!',
  close: 'Close',
});

const PublishModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { isModalOpened, setModalStatus, publishedDomain } = props;

  return (
    <ModalDialog
      isOpen={isModalOpened}
      onRequestDismiss={() => setModalStatus(null)}
      className="publish-modal"
    >
      <ModalDialogContent aria-label="dialog-content">
        <FluidImage
          className="confetti-image"
          src={`${window.vbcConfig.host}/images/confetti.svg`}
          alt={t(messages.confettiAlt.id)}
        />
        <ModalDialogNav>
          <ModalDialogCloseButton />
        </ModalDialogNav>
        <ModalDialogHeader>
          <ModalDialogTitle>
            <div className="title-content">{t(messages.congrats.id)}</div>
          </ModalDialogTitle>
        </ModalDialogHeader>
        <ModalDialogBody>
          <FlexBox alignItems="center" flexDirection="column" m={'5'}>
            <Typography fontSize={'large'} mb={'5'} textAlign="center">
              {t(messages.changesLiveMobile.id)}
            </Typography>
            <Link
              className="swan-button swan-button-skin-primary"
              to={publishedDomain}
              target="_blank"
            >
              {t(messages.view.id)}
            </Link>
          </FlexBox>
        </ModalDialogBody>
      </ModalDialogContent>
    </ModalDialog>
  );
};

export default PublishModal;
